/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment

import {
  Theme as NavigationTheme,
  ThemeProvider,
  DarkTheme as NavigationDarkTheme,
  DefaultTheme as NavigationLightTheme,
} from "@react-navigation/native";
import { useColorScheme } from "nativewind";

export function ReactNavigationThemeProvider(props: {
  children: React.ReactNode;
}) {
  const { children } = props;
  const { colorScheme } = useColorScheme();
  return <ThemeProvider value={DarkTheme}>{children}</ThemeProvider>;
}

const LightTheme: NavigationTheme = {
  dark: false,
  colors: {
    primary: "rgb(2, 2, 3)", // text-primary
    background: "rgb(252, 252, 253)", // surface-primary
    border: "rgb(226, 226, 228)", // border-subtle
    card: "rgb(252, 252, 253)", // surface-primary
    notification: "rgb(252, 252, 253)", // surface-primary
    text: "rgb(2, 2, 3)", // text-primary
  },
  fonts: NavigationLightTheme.fonts,
};

const DarkTheme: NavigationTheme = {
  dark: true,
  colors: {
    primary: "rgb( 238, 238, 240))",
    background: "rgb(14, 13, 15)",
    border: "rgb(50, 48, 53)",
    card: "rgb(14, 13, 15)",
    notification: "rgb(14, 13, 15)",
    text: "rgb(238, 238, 240)",
  },
  fonts: NavigationDarkTheme.fonts,
};
